import { useState, useEffect } from "react";
import axios from "axios";
import { baseURL } from "../../services/axiosConfig";
import useDeviceType from "../../Utiles/FindDevice";
import "react-toastify/dist/ReactToastify.css";
import { refreshTokenV2 } from "../../services/api";

import { ReactComponent as UpArrow } from '../../assets/up_arrow.svg';
import { ReactComponent as DownArrow } from '../../assets/down_arrow.svg';
import DownloadIcon from "../../Asserts/images/download_icon.svg"
import moment from "moment/moment";
import useToastMessage from "../../Utiles/Toaster";
import { Toaster } from "react-hot-toast";
import { useDispatch } from "react-redux";

export const CircularLoader = ({ isMobile = false }) => (
  <tr>
    <td colSpan="7" className="px-6 py-16 text-center">
      <div className="flex justify-center items-center">
        <div className={`animate-spin rounded-full border-b-2 border-blue-500 ${isMobile ? 'h-8 w-8' : 'h-12 w-12'}`}></div>
      </div>
    </td>
  </tr>
);

function AmountDisplay({ amount, status, isMobile = false }) {
  const isSuccess = status === "Success";
  const ArrowIcon = isSuccess ? UpArrow : DownArrow;
  const color = isSuccess ? "#00c05b" : "#ff4956";
  
  return (
    <div className="flex items-center justify-start gap-1">
      <ArrowIcon fill={color} className={isMobile ? "w-2 h-2" : "w-5 h-5"} />
      <span className={`${isMobile ? 'text-xs' : 'text-sm'} flex items-center gap-0.5 font-archivo font-medium ${isSuccess ? 'text-[#00c05b]' : 'text-[#ff4956]'}`}>
        <span className="text-[17px]">$</span> {amount}
      </span>
    </div>
  );
};

function StatusBadge({ status, isMobile = false }) {
  const isSuccess = status === "Success";
  
  return (
    <div className={`inline-flex items-center px-2 py-1 rounded-full ${isMobile ? 'text-xs' : 'text-xs'} font-medium ${
      isSuccess 
        ? 'bg-green-50 text-green-600 border border-green-200' 
        : 'bg-red-50 text-red-600 border border-red-200'
    }`}>
      <div className={`${isMobile ? 'w-1 h-1' : 'w-1.5 h-1.5'} rounded-full mr-1 ${
        isSuccess ? 'bg-green-500' : 'bg-red-500'
      }`} />
      {isSuccess ? 'Success' : 'Failed'}
    </div>
  );
}

function DownloadButton({ onClick, isMobile = false, payment_status }) {
  return (
    <button
      onClick={onClick}
      className={`${payment_status === "Failure" ? 'cursor-not-allowed opacity-50' : 'hover:underline'} mx-auto text-blue-500 hover:text-blue-700 font-medium ${isMobile ? 'text-xs' : 'text-sm'} flex items-center justify-center gap-1 transition-colors`}
    >
      Download
      <img src={DownloadIcon} alt="Download" className={isMobile ? "w-3 h-3" : "w-4 h-4"} />
    </button>
  );
}

function Pagination({ currentPage, totalPages, onPageChange, isMobile = false }) {
  return (
    <div className={`flex items-center gap-1 ${isMobile ? 'justify-end mt-4' : 'justify-end mt-6'}`}>
      <button 
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`w-8 h-8 flex items-center justify-center ${isMobile ? 'text-xs' : 'text-sm'} text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed hover:bg-gray-100 rounded border border-gray-200 bg-white`}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.5 9L4.5 6L7.5 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      
      {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={`w-8 h-8 flex items-center justify-center ${isMobile ? 'text-xs' : 'text-sm'} font-medium rounded border transition-colors ${
            page === currentPage 
              ? 'bg-blue-500 text-white border-blue-500 shadow-sm' 
              : 'text-gray-600 hover:bg-gray-50 border-gray-200 bg-white'
          }`}
        >
          {page}
        </button>
      ))}
      
      <button 
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`w-8 h-8 flex items-center justify-center ${isMobile ? 'text-xs' : 'text-sm'} text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed hover:bg-gray-100 rounded border border-gray-200 bg-white`}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.5 3L7.5 6L4.5 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );
}

export default function MyTransactions({dateRange}) {
  const dispatch = useDispatch()
  const [transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const deviceType = useDeviceType();
  const {showErrorToast} = useToastMessage()

  const from = dateRange[0] ? moment(dateRange[0]).format("YYYY-MM-DD") : null;
  const to = dateRange[1] ? moment(dateRange[1]).format("YYYY-MM-DD") : null;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const fetchTransactions = async (page = 1) => {
  setLoading(true);
  try {

    const params = new URLSearchParams({
      page: page.toString()
    });
    
    if (from) {
      params.append('from', from);
    }
    if (to) {
      params.append('to', to);
    }
    
    const response = await axios.get(`${baseURL}/pot/purchases?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(localStorage.getItem("access_token"))}`,
      },
    });
    
    if (response.status === 200) {
      setTransactions(response?.data?.results || []);
      setTotalPages(Math.ceil(response?.data?.count / 10) || 1);
    }
    
    if (response.status === 401) {
      await refreshTokenV2(dispatch);
      return;
    }

  } catch (error) {
    console.error("Error fetching transactions:", error);
    if (error?.response?.status === 401) {
      await refreshTokenV2(dispatch);
      fetchTransactions(page);
    } else {
      console.error("Error fetching transactions:", error);
      setTransactions([]);
    }
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchTransactions(currentPage);
  }, [currentPage, from, to]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      setCurrentPage(page);
    }
  };

const handleDownload = async (orderId, transaction_id, payment_status) => {
  try {
    const { data } = await axios.get(`${baseURL}/pot/receipt-pdf/${orderId}/`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(localStorage.getItem("access_token"))}`,
      },
      responseType: 'blob',
    });

    const blob = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${transaction_id}_receipt.pdf`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

  } catch (error) {
    if (error?.response?.status === 401) {
      await refreshTokenV2(dispatch);
      handleDownload(orderId, transaction_id);
    }
  }
};


  if (deviceType === 'mobile') {
    return (
      <div className="p-3 min-h-screen bg-gray-50">
        <Toaster
        position="top-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
        <div className="">
          <div className="overflow-x-auto bg-white">
            <table className="w-full min-w-[800px]">
              <thead>
                <tr  className="bg-gradient-to-r from-[#007fff] to-[#00c05b] text-white">
                  <th className="px-3 py-3 text-left text-xs font-semibold rounded-tl-lg whitespace-nowrap">Transaction ID</th>
                  <th className="px-3 py-3 text-left text-xs font-semibold whitespace-nowrap">Purchase Date</th>
                  <th className="px-3 py-3 text-left text-xs font-semibold whitespace-nowrap">Tokens Purchased</th>
                  <th className="px-3 py-3 text-left text-xs font-semibold whitespace-nowrap">Amount Paid</th>
                  <th className="px-3 py-3 text-left text-xs font-semibold whitespace-nowrap">Transaction Fee</th>
                  <th className="px-3 py-3 text-left text-xs font-semibold whitespace-nowrap">Payment Status</th>
                  <th className="px-3 py-3 text-left text-xs font-semibold rounded-tr-lg whitespace-nowrap">Download Receipt</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {loading ? (
                  <CircularLoader isMobile={true} />
                ) : transactions.length > 0 ? transactions.map((transaction, index) => (
                  <tr key={transaction.id} className={index % 2 !== 0 ? 'bg-[#f6faff]' : 'bg-white'}>
                    <td className="px-3 py-3 text-xs text-gray-600 font-mono whitespace-nowrap">
                      {transaction.transaction_id}
                    </td>
                    <td className="px-3 py-3 text-xs text-gray-600 whitespace-nowrap">
                      {formatDate(transaction.transfer_at)}
                    </td>
                    <td className="px-3 py-3 text-xs text-gray-600 text-center">
                      {transaction.token}
                    </td>
                    <td className="px-4 py-3">
                      <AmountDisplay amount={transaction.amount} status={transaction.transaction_status} isMobile={true} />
                    </td>
                    <td className="px-3 py-3 text-xs text-gray-600 text-center">
                      {transaction.transaction_fee}
                    </td>
                    <td className="px-3 py-3">
                      <StatusBadge status={transaction.transaction_status} isMobile={true} />
                    </td>
                    <td className="px-3 py-3">
                      <DownloadButton payment_status={transaction?.transaction_status} onClick={() => handleDownload(transaction.order_id, transaction.transaction_id, transaction?.transaction_status)} isMobile={true} />
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="7" className="px-3 py-8 text-center text-gray-500 text-xs">
                      No transactions found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          
          {transactions.length > 0 && !loading && (
            <div className="p-3 border-t border-gray-200 bg-white">
              <Pagination 
                currentPage={currentPage} 
                totalPages={totalPages} 
                onPageChange={handlePageChange}
                isMobile={true}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  // Desktop view
  return (
    <div className="py-2 px-6 bg-[#F6FAFF] w-full">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      <div className="w-full">
        <div className="">
          <div className="px-6 py-2 border-b border-gray-200">
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="">
                <tr className="bg-gradient-to-r from-[#007fff] to-[#00c05b] text-white">
                  <th className="px-6 py-4 text-left text-sm font-semibold rounded-tl-lg">Transaction ID</th>
                  <th className="px-6 py-4 text-center text-sm font-semibold">Purchase Date</th>
                  <th className="px-6 py-4 text-center text-sm font-semibold">Tokens Purchased</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold">Amount Paid</th>
                  <th className="px-6 py-4 text-center text-sm font-semibold">Transaction Fee</th>
                  <th className="px-6 py-4 text-center text-sm font-semibold">Payment Status</th>
                  <th className="px-6 py-4 text-center text-sm font-semibold rounded-tr-lg">Download Receipt</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {loading ? (
                  <CircularLoader />
                ) : transactions.length > 0 ? transactions.map((transaction, index) => (
                  <tr key={transaction.id} className={index % 2 !== 0 ? 'bg-[#f6faff]' : 'bg-white'}>
                    <td className="px-6 py-4 text-sm text-[#00000099] font-archivo rounded-b-lg font-mono">
                      {transaction?.transaction_id}
                    </td>
                    <td className="px-6 py-4 text-sm text-center text-[#00000099] font-archivo">
                      {formatDate(transaction?.transfer_at)}
                    </td>
                    <td className="px-6 py-4 text-sm text-[#00000099] text-center font-archivo">
                      {transaction?.token}
                    </td>
                    <td className="px-6 font-archivo py-4 mx-auto">
                      <AmountDisplay amount={transaction?.amount} status={transaction?.transaction_status} />
                    </td>
                    <td className="px-6 py-4 text-sm text-[#00000099] text-center font-archivo">
                      {transaction?.transaction_fee}
                    </td>
                    <td className="px-6 py-4 font-archivo text-center">
                      <StatusBadge status={transaction?.transaction_status} />
                    </td>
                    <td className="px-6 py-4 rounded-b-lg font-archivo">
                      <DownloadButton payment_status={transaction?.transaction_status} onClick={() => handleDownload(transaction.order_id, transaction.transaction_id, transaction?.transaction_status)} />
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="7" className="px-6 py-8 text-center text-gray-500">
                      No transactions found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {transactions.length > 0 && !loading && (
            <div className="px-6 py-2">
              <Pagination 
                currentPage={currentPage} 
                totalPages={totalPages} 
                onPageChange={handlePageChange} 
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
